import axiosInstance from './base.api';
import { getEnvironmentVariable } from '../utils';

export type CMSTemplate = {
    id: string;
    title: string;
    icon: string;
};

type CMSTemplateDTO = {
    id: string;
    name: string;
    img: string;
}[];

type WebsiteContent = {
    title: string;
    description: string;
    theme: string;
    default_page: string;
};

type WebsitePageContent = {
    name: string;
    title: string;
    html: string;
    css: string;
    js: string;
};

type GenerateWebsiteDTO = {
    Website: WebsiteContent;
    Pages: WebsitePageContent[];
    Assets: [];
    website_id: string;
    saved_to_website: boolean;
}

export type GetWebsiteContentDTO = {
    Website: WebsiteContent;
    Pages: WebsitePageContent[];
    Assets: [];
    website_id: string;
    saved_to_website: boolean;
}

export type WebsitePage = {
    id: number;
    subpageId: number;
    title: string;
    url: string;
    pageUrl: string;
};

type GetWebsitePagesDTO = {
    id: number;
    parent_id: number;
    decision_id: number;
    name: string;
    url: string;
    title: string;
    enabled: number;
}[];

const baseUrl = getEnvironmentVariable('REACT_APP_IMAGE_BASE_URL');
const websiteBaseUrl = getEnvironmentVariable('REACT_APP_PLATFORM_URL') + '/page';

export const getCMSTemplates = async (): Promise<CMSTemplate[]> => {
    const response = await axiosInstance.post<CMSTemplateDTO>('/templates');

    return response.data.map(item => {
        return {
            id: item.id,
            title: item.name,
            icon: baseUrl + item.img,
        };
    });
};

export const generateWebsite = async (prompt: string, websiteId?: string): Promise<GenerateWebsiteDTO> => {
    const response = await axiosInstance.post<GenerateWebsiteDTO>(`/openai/generate-website?id=${websiteId}`, {
        prompt,
    });
    return response.data;
};


export const getWebsiteContent = async (websiteId?: string): Promise<GetWebsiteContentDTO> => {
    const response = await axiosInstance.post<GetWebsiteContentDTO>(`/openai/generate-website?id=${websiteId}`, {});
    return response.data;
};

export const getWebsitePages = async (websiteId?: string): Promise<WebsitePage[]> => {
    const response = await axiosInstance.get<GetWebsitePagesDTO>(`/page-vvveb/list?id=${websiteId}`);
    return response.data.map(page => ({
        id: page.decision_id,
        subpageId: page.id,
        title: page.title,
        url: `${websiteBaseUrl}/${page.decision_id}${page.url}`.replace(/^http:\/\//, 'https://'),
        pageUrl: page.url,
    }));
};

export const saveWebsitePage = async (websiteId: string, subpageURL: string, content: {
    html: string; css: string; js: string
}): Promise<void> => {
    debugger;
    await axiosInstance.post(`/page-vvveb/save?id=${websiteId}&url=${subpageURL}`, {
        html: content.html,
        css: content.css,
        javascript_after: content.js,
    });
};
